import {
  INITIAL_EXTENDED_FIELD_DETAIL,
  ExtendedFieldsSourceType,
} from "us.collection.admin/constants";
import _ from "lodash";

/**
 * Retrieves the initial form values for an extended field based on the selected field ID.
 *
 * @param {number} selectedFieldId - The ID of the selected extended field.
 * @param {Array} fieldList - The list of available extended fields.
 * @returns {object} - A formatted object containing the extended field details.
 */
export const getExtendedFieldFormValues = (
  selectedFieldId: number,
  fieldList: Array<any>
): typeof INITIAL_EXTENDED_FIELD_DETAIL => {
  try {
    if (Array.isArray(fieldList)) {
      if (selectedFieldId > -1) {
        const {
          fieldName,
          fieldCategory,
          description,
          dataType,
          valueSource,
          valueType,
          dataTypeId,
        } =
          _.find(fieldList, {
            id: selectedFieldId,
          }) ?? {};

        return {
          id: selectedFieldId,
          fieldName: fieldName ? fieldName : "",
          fieldCategory: fieldCategory ? fieldCategory : "",
          description: description ? description : "",
          dataType: dataType ? dataType : "",
          dataTypeId: dataTypeId ? dataTypeId : undefined,
          valueList:
            valueSource && valueType != ExtendedFieldsSourceType.SP
              ? valueSource?.trim()?.split(",")
              : [undefined],
          storedProcedure:
          valueSource && valueType == ExtendedFieldsSourceType.SP
              ? valueSource
              : undefined,
          valueType,
        };
      } else {
        return INITIAL_EXTENDED_FIELD_DETAIL;
      }
    } else {
      return INITIAL_EXTENDED_FIELD_DETAIL;
    }
  } catch (error) {
    return INITIAL_EXTENDED_FIELD_DETAIL;
  }
};
